import React from 'react'
import { Button } from '@heroui/react'
import { IMostSearchedAPIResponseData } from '@/src/types/mostSearched'
import { SearchSVG } from '@/src/ui/AllSVG'

interface MostSearchedProps {
    mostSearchedData: IMostSearchedAPIResponseData[]
    activeTag: string
    onSelect: (tag: string) => void
}

export default function MostSearched({ mostSearchedData, activeTag, onSelect }: MostSearchedProps) {

    return (
        <>
            {mostSearchedData && mostSearchedData?.length > 0 && <h3 className="text-sm font-semibold tracking-[0.14px] uppercase">Most Searched</h3>}
            <div className="flex flex-wrap gap-1.5 md:gap-2">
                {mostSearchedData && mostSearchedData?.length > 0 ? mostSearchedData?.map((item, index) => (
                    <Button
                        key={index}
                        onClick={() => onSelect(item?.title)}
                        className={`global_btn rounded_full ${activeTag === item?.title ? 'bg_primary' : 'bg-white! text-body-color!'} min-w-fit! h-auto! min-h-8! px-3! py-1! text-xs! md:min-h-10! md:px-6! md:py-2! md:text-sm`}
                    >
                        {item?.title}
                    </Button>
                )) : (
                    <div className="flex flex-col items-center justify-center gap-4 py-10 w-full text-center">
                        <span className="opacity-10 [&>svg]:w-10 [&>svg]:h-10">
                            <SearchSVG />
                        </span>
                        <div className="space-y-1.5">
                            <p className="text-sm tracking-[0.2em] uppercase text-body-color/50">Start typing to search</p>
                            <p className="text-[11px] tracking-wide text-body-color/30">Discover products, brands &amp; styles</p>
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}
